export interface OrganizationContextMembership {
  org_id: string
  joined_at: string
}

/**
 * The client mirror of `private.effective_org_id_for_user`.
 *
 * A saved pointer is a preference, not authority. It wins only while the user
 * is still a member; otherwise the deterministic oldest current membership is
 * the active workspace. No memberships means personal context.
 */
export function resolveActiveOrganizationId(
  explicitActiveOrgId: string | null | undefined,
  memberships: readonly OrganizationContextMembership[],
): string | null {
  if (
    explicitActiveOrgId &&
    memberships.some((membership) => membership.org_id === explicitActiveOrgId)
  ) {
    return explicitActiveOrgId
  }

  const oldest = [...memberships].sort((a, b) => {
    const joined = a.joined_at.localeCompare(b.joined_at)
    return joined !== 0 ? joined : a.org_id.localeCompare(b.org_id)
  })[0]

  return oldest?.org_id ?? null
}
